var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom"},[_c('router-link',{attrs:{"to":"/sogl"}},[_vm._v(" Пользовательское соглашение ")]),_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(" Поддержка ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }